<template>
  <div class="table__filter">
    <div class="filter__tabs">
      <span
        v-for="(tab, i) in tabs"
        :key="i"
        :class="['filter__tabs-item', { active: activeTabIndex === i }]"
        :style="{ zIndex: -i }"
        @click="setActiveTab(tab, i)"
      >
        {{ tab.name }}
        <span :style="{ color: colors[i] || null, marginLeft: '7px' }">{{
          tab.count
        }}</span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableFilter',
  props: {
    tabs: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    propActiveTabIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      colors: ['#C01082', '#86C677', '#EA803A', '#1170B8', '#EF424D', '#173F7D'],
      activeTabIndex: this.propActiveTabIndex
    }
  },
  methods: {
    setActiveTab (tab, i) {
      if (!this.loading && i !== this.activeTabIndex) {
        this.activeTabIndex = i
        this.$emit('setActiveTab', tab, i)
      }
    }
  },
  watch: {
    propActiveTabIndex (val) {
      this.activeTabIndex = val
    }
  }
}
</script>

<style scoped lang="scss">
.table__filter {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;

  &::after {
    content: "";
    height: 1px;
    width: 100%;
    left: 0;
    bottom: 0;
    position: absolute;
    background: #eeeeee;
  }

  .filter__tabs {
    display: flex;
    z-index: 1;

    .filter__tabs-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      height: 46px;
      border-top: 1px solid #eeeeee;
      border-right: 1px solid #eeeeee;
      border-top-right-radius: 20px;
      padding: 13px 13px 13px 46px;
      font-size: 16px;
      color: #697178;
      margin-left: -27px;
      position: relative;
      transition: 0.2s;

      &:first-of-type {
        border-left: 1px solid #eeeeee;
        padding-left: 20px;
        margin-left: 0;

        &.active::after {
          width: 100%;
        }
      }

      &.active {
        color: black;

        &::after {
          content: "";
          height: 1px;
          width: calc(100% - 27px);
          right: 0;
          bottom: 0;
          position: absolute;
          background: white;
        }
      }
    }
  }
}
</style>
